import { CommandBarButton } from "@fluentui/react";
import { ExcelExport } from "@progress/kendo-react-excel-export";
import { Workbook } from "@progress/kendo-ooxml";
import { saveAs } from "@progress/kendo-file-saver";
import React from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { selectShownFleets } from "../../store/fleetsPage";
import { useSelector } from "../../store/hooks";
import { transformFleetsForExcel } from "../../utils/excel";

type Props = {
  refExcelExport: ExcelExport;
  columns: any[];
  fileName: string;
};

export const ExportExcelFleetsButton = ({
  refExcelExport,
  columns,
  fileName,
}: Props) => {
  const { t } = useTranslation();
  const taxonomy = useSelector((s) => s.taxonomy);
  const fleets = useSelector(selectShownFleets);

  return (
    <StyledCommandBarButton
      iconProps={{ iconName: "ExcelDocument" }}
      text="Export Excel"
      onClick={() => {
        const data = transformFleetsForExcel({
          fleets,
          columns,
          t,
          taxonomy,
        });

        const workbook = refExcelExport.workbookOptions(data);
        const sheet = workbook.sheets[0];

        // Find column indices for conditional red text
        const visibleColumns = columns.filter(
          (c) => c.excel?.isVisible !== false
        );
        const fleetNameIdx = visibleColumns.findIndex(
          (c) => c.key === "fleetName"
        );
        const clientNameIdx = visibleColumns.findIndex(
          (c) => c.key === "clientName"
        );

        // Row 0 is the header, data rows start at index 1
        for (let i = 1; i < sheet.rows.length; i++) {
          const fleet = fleets[i - 1];
          if (fleet?.isCancelled && fleetNameIdx !== -1) {
            sheet.rows[i].cells[fleetNameIdx].color = "#ff0000";
          }
          if (fleet?.isFormerClient && clientNameIdx !== -1) {
            sheet.rows[i].cells[clientNameIdx].color = "#ff0000";
          }
        }

        new Workbook(workbook).toDataURL().then((dataURI) => {
          saveAs(dataURI, fileName + ".xlsx");
        });
      }}
    />
  );
};

const StyledCommandBarButton = styled(CommandBarButton)`
  height: 32px;

  &:hover {
    .ms-Button-icon {
      color: green;
    }
  }
`;
